import GeneralPage from './GeneralPage';
import TreatmentPage from './TreatmentPage';
import ThankYouPage from './ThankYouPage';
import ThankYou from './ThankYou';
import DoctorProfile from './DoctorProfile';
import ReviewsPage from './ReviewsPage';
import SpecialityPage from './SpecialityPage';
import ClinicPage from './ClinicPage';
import LocationPage from './LocationPage';
import LandingPage from './LandingPage';
import Author from './Author';
import AuthorList from './AuthorList';
import ReferFriendRewardLandingPage from './ReferFriendRewardLandingPage';
import SplitTest from './SplitTest';
import PaymentUpdatePage from './PaymentUpdatePage';

export const pageMapping = {
  generalPage: GeneralPage,
  treatmentPage: TreatmentPage,
  thankYouPage: ThankYouPage,
  thankYou: ThankYou,
  doctorProfile: DoctorProfile,
  reviewsPage: ReviewsPage,
  specialityPage: SpecialityPage,
  clinicPage: ClinicPage,
  locationPage: LocationPage,
  landingPage: LandingPage,
  author: Author,
  authorList: AuthorList,
  referFriendRewardLandingPage: ReferFriendRewardLandingPage,
  splitTest: SplitTest,
  paymentUpdatePage: PaymentUpdatePage,
};
